module.exports = __webpack_public_path__ + "assets-cabinet/img/close--button.e5e3b26e.svg";